<template>
  <div
    :class="[
      'pThumb flex-col flex__center clickable margin-right-10 wrapper',
      active ? 'active' : ''
    ]"
    @click="$emit('click')"
    @dragstart ="$emit('dragstart')"

  >

    <div class="pBgThumb" :style="`background-image: url( ${url} ); background-size: contain;`"></div>
    <div class="pIndex flex-row font-size__small font-weight__bold">
      <span>
        {{ title }}
      </span>
    </div>
    <div :class="['markIsModified', isModify === true ? 'on' : 'off']"></div>
  </div>
</template>

<script>
  export default {
    name: "p-thumbnail",
    props: ["url", "title", "active", "isModify"],
    methods:{

    }

  };
</script>

<style lang="css" scoped>
.wrapper{
  width: 370px;
}
</style>



// WEBPACK FOOTER //
// src/views/common/noteDocs/p-thumbnail.vue